import { QueryKey, useQuery } from '@tanstack/react-query'
import { shiftRosterByShiftIdKey } from './keys'
import {
  getShiftRosterByShiftId,
  ShiftRoster,
} from 'api/shifts/getShiftRosterByShiftId'
import { AxiosError } from 'axios'

export const useShiftRosterByShiftIdQuery = (
  shiftId: number,
  enabled: boolean
) => {
  return useQuery<ShiftRoster, AxiosError, ShiftRoster, QueryKey>({
    queryKey: shiftRosterByShiftIdKey(shiftId),
    queryFn: () => getShiftRosterByShiftId(shiftId),
    enabled,
  })
}
